export default {
  achievementLevelsBy: '{entity} by:',
  addDescriptorToAchievementLevels: 'Add Descriptor to {entity}:',
  percentage: 'Percentage',
  score: 'Score',
  showDescriptors: 'Show Descriptors',
  hideDescriptors: 'Hide Descriptors',
  achievementLevelScore: '{entity} Score',
}
